@if (topicsForWordclouds.length === 0 && !isLoading) {
  <div class="no-graphic">
    <img src="assets/imgs/undraw/undraw_no_data.svg" alt="Nessun Topic" />
    <span>Nessun Topic recuperato</span>
  </div>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}

<section class="cards-container">
  @for (topic of topicsForWordclouds; track topic) {
    <div class="card">
      <div class="card-container">
        <div class="header">{{ topic.name }}</div>
        <div class="words-container">
          @for (word of topic.words; track word) {
            <div class="word">
              {{ word }}
            </div>
          }
        </div>
      </div>
    </div>
  }
</section>
